export const isAbortError = (error: unknown): boolean => {
	if (error instanceof DOMException) {
		return error.name === 'AbortError'
	}

	return error instanceof Error && error.name === 'AbortError'
}
